// AUTO-GENERATED fallback catalog (from `cardiovascular_medication_dropdown.xlsx`).
// Each entry: { drugName, category, subCategory, drugClass, route, commonDoseStrengths, commonFrequency, rxOtc }.
//
// The authoritative catalog lives in the backend DB (table: `medication_catalog`,
// endpoints under `/medication-catalog/`). This array is used only as an
// offline fallback when the API is unreachable, and as the seed payload sent
// to `/medication-catalog/seed` the first time the catalog is empty.

const FALLBACK_MEDICATIONS = [
  {
    "drugName": "Acetaminophen",
    "category": "OTC",
    "subCategory": "Pain/Fever",
    "drugClass": "Analgesic",
    "route": "Oral",
    "commonDoseStrengths": "325 mg; 500 mg; 650 mg",
    "commonFrequency": "Every 4 to 8 hours as needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Acetazolamide",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Carbonic Anhydrase Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "125 mg; 250 mg; 500 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Alirocumab",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "PCSK9 Inhibitor",
    "route": "Injection",
    "commonDoseStrengths": "75 mg; 150 mg",
    "commonFrequency": "Every 2 weeks",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Aliskiren",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Direct Renin Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "150 mg; 300 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Allopurinol",
    "category": "Other",
    "subCategory": "Gout",
    "drugClass": "Xanthine Oxidase Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "100 mg; 300 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Alprazolam",
    "category": "Other",
    "subCategory": "Anxiety",
    "drugClass": "Benzodiazepine",
    "route": "Oral",
    "commonDoseStrengths": "0.25 mg; 0.5 mg; 1 mg",
    "commonFrequency": "Once daily to three times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Alteplase",
    "category": "Cardiovascular",
    "subCategory": "Acute Care",
    "drugClass": "Thrombolytic",
    "route": "IV",
    "commonDoseStrengths": "50 mg; 100 mg",
    "commonFrequency": "Per protocol",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Aluminum hydroxide/magnesium hydroxide",
    "category": "OTC",
    "subCategory": "GI",
    "drugClass": "Antacid",
    "route": "Oral",
    "commonDoseStrengths": "Tablet; Suspension",
    "commonFrequency": "As needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Amlodipine",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Calcium Channel Blocker",
    "route": "Oral",
    "commonDoseStrengths": "2.5 mg; 5 mg; 10 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Amlodipine/atorvastatin",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "5/10 mg; 10/10 mg; 5/20 mg; 10/20 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Amlodipine/benazepril",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "2.5/10 mg; 5/10 mg; 5/20 mg; 10/20 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Amlodipine/olmesartan",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "5/20 mg; 5/40 mg; 10/20 mg; 10/40 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Amlodipine/valsartan",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "5/160 mg; 10/160 mg; 5/320 mg; 10/320 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Amiodarone",
    "category": "Cardiovascular",
    "subCategory": "Electrophysiology",
    "drugClass": "Antiarrhythmic",
    "route": "Oral",
    "commonDoseStrengths": "100 mg; 200 mg; 400 mg",
    "commonFrequency": "Once daily or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Amoxicillin",
    "category": "Other",
    "subCategory": "Infectious Disease",
    "drugClass": "Penicillin Antibiotic",
    "route": "Oral",
    "commonDoseStrengths": "250 mg; 500 mg; 875 mg",
    "commonFrequency": "Two to three times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Amoxicillin/clavulanate",
    "category": "Other",
    "subCategory": "Infectious Disease",
    "drugClass": "Penicillin Antibiotic",
    "route": "Oral",
    "commonDoseStrengths": "500/125 mg; 875/125 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Apixaban",
    "category": "Cardiovascular",
    "subCategory": "Electrophysiology",
    "drugClass": "Anticoagulant",
    "route": "Oral",
    "commonDoseStrengths": "2.5 mg; 5 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Aspirin",
    "category": "Cardiovascular",
    "subCategory": "CAD",
    "drugClass": "Antiplatelet",
    "route": "Oral",
    "commonDoseStrengths": "81 mg; 100 mg; 300 mg; 325 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Aspirin/dipyridamole",
    "category": "Cardiovascular",
    "subCategory": "Stroke Prevention",
    "drugClass": "Antiplatelet Combination",
    "route": "Oral",
    "commonDoseStrengths": "25/200 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Atenolol",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Beta Blocker",
    "route": "Oral",
    "commonDoseStrengths": "25 mg; 50 mg; 100 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Atorvastatin",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "Statin",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 20 mg; 40 mg; 80 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Azilsartan",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "ARB",
    "route": "Oral",
    "commonDoseStrengths": "40 mg; 80 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Azithromycin",
    "category": "Other",
    "subCategory": "Infectious Disease",
    "drugClass": "Macrolide Antibiotic",
    "route": "Oral",
    "commonDoseStrengths": "250 mg; 500 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Bempedoic acid",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "ACL Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "180 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Benazepril",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "ACE Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 10 mg; 20 mg; 40 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Bisacodyl",
    "category": "OTC",
    "subCategory": "Constipation",
    "drugClass": "Stimulant Laxative",
    "route": "Oral",
    "commonDoseStrengths": "5 mg",
    "commonFrequency": "Once daily as needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Bisoprolol",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Beta Blocker",
    "route": "Oral",
    "commonDoseStrengths": "1.25 mg; 2.5 mg; 5 mg; 10 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Bismuth subsalicylate",
    "category": "OTC",
    "subCategory": "GI",
    "drugClass": "Antidiarrheal",
    "route": "Oral",
    "commonDoseStrengths": "262 mg",
    "commonFrequency": "As needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Bumetanide",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Loop Diuretic",
    "route": "Oral",
    "commonDoseStrengths": "0.5 mg; 1 mg; 2 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Candesartan",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "ARB",
    "route": "Oral",
    "commonDoseStrengths": "4 mg; 8 mg; 16 mg; 32 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Candesartan/hydrochlorothiazide",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "16/12.5 mg; 32/12.5 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Canagliflozin",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "SGLT2 Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "100 mg; 300 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Carvedilol",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Beta Blocker",
    "route": "Oral",
    "commonDoseStrengths": "3.125 mg; 6.25 mg; 12.5 mg; 25 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Carvedilol CR",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Beta Blocker",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 20 mg; 40 mg; 80 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Cefdinir",
    "category": "Other",
    "subCategory": "Infectious Disease",
    "drugClass": "Cephalosporin Antibiotic",
    "route": "Oral",
    "commonDoseStrengths": "300 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Cephalexin",
    "category": "Other",
    "subCategory": "Infectious Disease",
    "drugClass": "Cephalosporin Antibiotic",
    "route": "Oral",
    "commonDoseStrengths": "250 mg; 500 mg",
    "commonFrequency": "Two to four times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Cetirizine",
    "category": "OTC",
    "subCategory": "Allergy",
    "drugClass": "Antihistamine",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 10 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Chlorthalidone",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Thiazide-like Diuretic",
    "route": "Oral",
    "commonDoseStrengths": "12.5 mg; 25 mg; 50 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Cholecalciferol",
    "category": "OTC",
    "subCategory": "Supplements",
    "drugClass": "Vitamin D",
    "route": "Oral",
    "commonDoseStrengths": "1000 IU; 2000 IU; 5000 IU",
    "commonFrequency": "Once daily",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Cilostazol",
    "category": "Cardiovascular",
    "subCategory": "Peripheral Vascular",
    "drugClass": "Antiplatelet",
    "route": "Oral",
    "commonDoseStrengths": "50 mg; 100 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Ciprofloxacin",
    "category": "Other",
    "subCategory": "Infectious Disease",
    "drugClass": "Fluoroquinolone Antibiotic",
    "route": "Oral",
    "commonDoseStrengths": "250 mg; 500 mg; 750 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Clarithromycin",
    "category": "Other",
    "subCategory": "Infectious Disease",
    "drugClass": "Macrolide Antibiotic",
    "route": "Oral",
    "commonDoseStrengths": "250 mg; 500 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Clonidine",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Alpha-2 Agonist",
    "route": "Oral",
    "commonDoseStrengths": "0.1 mg; 0.2 mg; 0.3 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Clonidine patch",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Alpha-2 Agonist",
    "route": "Transdermal",
    "commonDoseStrengths": "0.1 mg/day; 0.2 mg/day; 0.3 mg/day",
    "commonFrequency": "Weekly",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Clopidogrel",
    "category": "Cardiovascular",
    "subCategory": "CAD",
    "drugClass": "Antiplatelet",
    "route": "Oral",
    "commonDoseStrengths": "75 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Colchicine",
    "category": "Other",
    "subCategory": "Gout",
    "drugClass": "Anti-inflammatory",
    "route": "Oral",
    "commonDoseStrengths": "0.5 mg; 0.6 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Dabigatran",
    "category": "Cardiovascular",
    "subCategory": "Electrophysiology",
    "drugClass": "Anticoagulant",
    "route": "Oral",
    "commonDoseStrengths": "75 mg; 110 mg; 150 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Dapagliflozin",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "SGLT2 Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 10 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Desloratadine",
    "category": "OTC",
    "subCategory": "Allergy",
    "drugClass": "Antihistamine",
    "route": "Oral",
    "commonDoseStrengths": "5 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Dexamethasone",
    "category": "Other",
    "subCategory": "Inflammation",
    "drugClass": "Corticosteroid",
    "route": "Oral",
    "commonDoseStrengths": "0.5 mg; 4 mg",
    "commonFrequency": "Once daily or as directed",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Diazepam",
    "category": "Other",
    "subCategory": "Anxiety",
    "drugClass": "Benzodiazepine",
    "route": "Oral",
    "commonDoseStrengths": "2 mg; 5 mg; 10 mg",
    "commonFrequency": "Once daily to four times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Digoxin",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Cardiac Glycoside",
    "route": "Oral",
    "commonDoseStrengths": "0.125 mg; 0.25 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Diltiazem",
    "category": "Cardiovascular",
    "subCategory": "Electrophysiology",
    "drugClass": "Rate Control",
    "route": "Oral",
    "commonDoseStrengths": "30 mg; 60 mg; 90 mg; 120 mg; 180 mg; 240 mg; 300 mg",
    "commonFrequency": "Once daily or multiple times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Diphenhydramine",
    "category": "OTC",
    "subCategory": "Allergy",
    "drugClass": "Antihistamine",
    "route": "Oral",
    "commonDoseStrengths": "25 mg; 50 mg",
    "commonFrequency": "Every 4 to 6 hours as needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Docusate sodium",
    "category": "OTC",
    "subCategory": "Constipation",
    "drugClass": "Stool Softener",
    "route": "Oral",
    "commonDoseStrengths": "100 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Dofetilide",
    "category": "Cardiovascular",
    "subCategory": "Electrophysiology",
    "drugClass": "Antiarrhythmic",
    "route": "Oral",
    "commonDoseStrengths": "125 mcg; 250 mcg; 500 mcg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Domperidone",
    "category": "Other",
    "subCategory": "GI",
    "drugClass": "Prokinetic",
    "route": "Oral",
    "commonDoseStrengths": "10 mg",
    "commonFrequency": "Three times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Doxazosin",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Alpha Blocker",
    "route": "Oral",
    "commonDoseStrengths": "1 mg; 2 mg; 4 mg; 8 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Dronedarone",
    "category": "Cardiovascular",
    "subCategory": "Electrophysiology",
    "drugClass": "Antiarrhythmic",
    "route": "Oral",
    "commonDoseStrengths": "400 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Dulaglutide",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "GLP-1 Receptor Agonist",
    "route": "Injection",
    "commonDoseStrengths": "0.75 mg; 1.5 mg; 3 mg; 4.5 mg",
    "commonFrequency": "Once weekly",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Edoxaban",
    "category": "Cardiovascular",
    "subCategory": "Electrophysiology",
    "drugClass": "Anticoagulant",
    "route": "Oral",
    "commonDoseStrengths": "15 mg; 30 mg; 60 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Empagliflozin",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "SGLT2 Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 25 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Enalapril",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "ACE Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "2.5 mg; 5 mg; 10 mg; 20 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Enalapril/hydrochlorothiazide",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "10/25 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Enoxaparin",
    "category": "Cardiovascular",
    "subCategory": "Anticoagulation",
    "drugClass": "LMWH",
    "route": "Injection",
    "commonDoseStrengths": "40 mg; 60 mg; 80 mg; 100 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Eplerenone",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "MRA",
    "route": "Oral",
    "commonDoseStrengths": "25 mg; 50 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Erythromycin",
    "category": "Other",
    "subCategory": "Infectious Disease",
    "drugClass": "Macrolide Antibiotic",
    "route": "Oral",
    "commonDoseStrengths": "250 mg; 500 mg",
    "commonFrequency": "Two to four times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Escitalopram",
    "category": "Other",
    "subCategory": "Mental Health",
    "drugClass": "SSRI",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 10 mg; 20 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Esomeprazole",
    "category": "OTC",
    "subCategory": "GI",
    "drugClass": "PPI",
    "route": "Oral",
    "commonDoseStrengths": "20 mg; 40 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Evolocumab",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "PCSK9 Inhibitor",
    "route": "Injection",
    "commonDoseStrengths": "140 mg; 420 mg",
    "commonFrequency": "Every 2 weeks or monthly",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Ezetimibe",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "Cholesterol Absorption Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "10 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Ezetimibe/atorvastatin",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "10/10 mg; 10/20 mg; 10/40 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Ezetimibe/rosuvastatin",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "10/5 mg; 10/10 mg; 10/20 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Famotidine",
    "category": "OTC",
    "subCategory": "GI",
    "drugClass": "H2 Blocker",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 20 mg; 40 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Fenofibrate",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "Fibrate",
    "route": "Oral",
    "commonDoseStrengths": "48 mg; 145 mg; 160 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Ferrous fumarate",
    "category": "OTC",
    "subCategory": "Supplements",
    "drugClass": "Iron",
    "route": "Oral",
    "commonDoseStrengths": "200 mg",
    "commonFrequency": "Once daily or twice daily",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Ferrous sulfate",
    "category": "OTC",
    "subCategory": "Supplements",
    "drugClass": "Iron",
    "route": "Oral",
    "commonDoseStrengths": "325 mg",
    "commonFrequency": "Once daily or twice daily",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Fexofenadine",
    "category": "OTC",
    "subCategory": "Allergy",
    "drugClass": "Antihistamine",
    "route": "Oral",
    "commonDoseStrengths": "60 mg; 120 mg; 180 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Finerenone",
    "category": "Cardiovascular",
    "subCategory": "Cardiorenal",
    "drugClass": "Mineralocorticoid Receptor Antagonist",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 20 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Flecainide",
    "category": "Cardiovascular",
    "subCategory": "Electrophysiology",
    "drugClass": "Antiarrhythmic",
    "route": "Oral",
    "commonDoseStrengths": "50 mg; 100 mg; 150 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Fluconazole",
    "category": "Other",
    "subCategory": "Infectious Disease",
    "drugClass": "Antifungal",
    "route": "Oral",
    "commonDoseStrengths": "50 mg; 100 mg; 150 mg; 200 mg",
    "commonFrequency": "Once daily or single dose",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Fluoxetine",
    "category": "Other",
    "subCategory": "Mental Health",
    "drugClass": "SSRI",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 20 mg; 40 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Folic acid",
    "category": "OTC",
    "subCategory": "Supplements",
    "drugClass": "Vitamin",
    "route": "Oral",
    "commonDoseStrengths": "1 mg; 5 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Furosemide",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Loop Diuretic",
    "route": "Oral",
    "commonDoseStrengths": "20 mg; 40 mg; 80 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Gemfibrozil",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "Fibrate",
    "route": "Oral",
    "commonDoseStrengths": "600 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Glibenclamide",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Sulfonylurea",
    "route": "Oral",
    "commonDoseStrengths": "5 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Gliclazide",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Sulfonylurea",
    "route": "Oral",
    "commonDoseStrengths": "30 mg MR; 60 mg MR; 80 mg",
    "commonFrequency": "Once daily or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Glimepiride",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Sulfonylurea",
    "route": "Oral",
    "commonDoseStrengths": "1 mg; 2 mg; 4 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Glipizide",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Sulfonylurea",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 10 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Glycerin suppository",
    "category": "OTC",
    "subCategory": "Constipation",
    "drugClass": "Laxative",
    "route": "Rectal",
    "commonDoseStrengths": "Adult suppository",
    "commonFrequency": "As needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Glyburide",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Sulfonylurea",
    "route": "Oral",
    "commonDoseStrengths": "1.25 mg; 2.5 mg; 5 mg",
    "commonFrequency": "Once daily or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Glyceryl trinitrate",
    "category": "Cardiovascular",
    "subCategory": "CAD",
    "drugClass": "Nitrate",
    "route": "Sublingual",
    "commonDoseStrengths": "0.3 mg; 0.4 mg; 0.6 mg",
    "commonFrequency": "Every 5 min as needed",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Hydralazine",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Direct Vasodilator",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 25 mg; 50 mg; 100 mg",
    "commonFrequency": "Two to four times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Hydralazine/isosorbide dinitrate",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Combination Vasodilator",
    "route": "Oral",
    "commonDoseStrengths": "20/37.5 mg",
    "commonFrequency": "Three times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Hydrochlorothiazide",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Thiazide Diuretic",
    "route": "Oral",
    "commonDoseStrengths": "12.5 mg; 25 mg; 50 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Hydrocortisone cream",
    "category": "OTC",
    "subCategory": "Dermatology",
    "drugClass": "Corticosteroid",
    "route": "Topical",
    "commonDoseStrengths": "1%",
    "commonFrequency": "One to four times daily",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Hydroxyzine",
    "category": "Other",
    "subCategory": "Allergy",
    "drugClass": "Antihistamine",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 25 mg; 50 mg",
    "commonFrequency": "As needed",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Icosapent ethyl",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "Omega-3",
    "route": "Oral",
    "commonDoseStrengths": "1 g",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Ibuprofen",
    "category": "OTC",
    "subCategory": "Pain/Fever",
    "drugClass": "NSAID",
    "route": "Oral",
    "commonDoseStrengths": "200 mg; 400 mg; 600 mg; 800 mg",
    "commonFrequency": "Every 6 to 8 hours as needed",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Insulin aspart",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Insulin",
    "route": "Injection",
    "commonDoseStrengths": "100 units/mL",
    "commonFrequency": "Before meals",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Insulin degludec",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Insulin",
    "route": "Injection",
    "commonDoseStrengths": "100 units/mL; 200 units/mL",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Insulin detemir",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Insulin",
    "route": "Injection",
    "commonDoseStrengths": "100 units/mL",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Insulin glargine",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Insulin",
    "route": "Injection",
    "commonDoseStrengths": "100 units/mL; 300 units/mL",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Insulin lispro",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Insulin",
    "route": "Injection",
    "commonDoseStrengths": "100 units/mL; 200 units/mL",
    "commonFrequency": "Before meals",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Insulin NPH",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Insulin",
    "route": "Injection",
    "commonDoseStrengths": "100 units/mL",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Isosorbide dinitrate",
    "category": "Cardiovascular",
    "subCategory": "CAD",
    "drugClass": "Nitrate",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 10 mg; 20 mg; 30 mg; 40 mg",
    "commonFrequency": "Two to three times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Isosorbide mononitrate",
    "category": "Cardiovascular",
    "subCategory": "CAD",
    "drugClass": "Nitrate",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 20 mg; 30 mg; 60 mg; 120 mg",
    "commonFrequency": "Once daily or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Ivabradine",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "If Channel Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 7.5 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Ketoconazole cream",
    "category": "Other",
    "subCategory": "Dermatology",
    "drugClass": "Antifungal",
    "route": "Topical",
    "commonDoseStrengths": "2%",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Labetalol",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Beta Blocker",
    "route": "Oral",
    "commonDoseStrengths": "100 mg; 200 mg; 300 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Lactulose",
    "category": "OTC",
    "subCategory": "Constipation",
    "drugClass": "Osmotic Laxative",
    "route": "Oral",
    "commonDoseStrengths": "Syrup",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Levocetirizine",
    "category": "OTC",
    "subCategory": "Allergy",
    "drugClass": "Antihistamine",
    "route": "Oral",
    "commonDoseStrengths": "5 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Levofloxacin",
    "category": "Other",
    "subCategory": "Infectious Disease",
    "drugClass": "Fluoroquinolone Antibiotic",
    "route": "Oral",
    "commonDoseStrengths": "250 mg; 500 mg; 750 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Levothyroxine",
    "category": "Other",
    "subCategory": "Endocrine",
    "drugClass": "Thyroid Hormone",
    "route": "Oral",
    "commonDoseStrengths": "25 mcg; 50 mcg; 75 mcg; 100 mcg; 125 mcg; 150 mcg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Lidocaine patch",
    "category": "Other",
    "subCategory": "Pain",
    "drugClass": "Local Anesthetic",
    "route": "Topical",
    "commonDoseStrengths": "5%",
    "commonFrequency": "Daily as directed",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Linagliptin",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "DPP-4 Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "5 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Liraglutide",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "GLP-1 Receptor Agonist",
    "route": "Injection",
    "commonDoseStrengths": "0.6 mg; 1.2 mg; 1.8 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Lisinopril",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "ACE Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "2.5 mg; 5 mg; 10 mg; 20 mg; 40 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Lisinopril/hydrochlorothiazide",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "10/12.5 mg; 20/12.5 mg; 20/25 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Loperamide",
    "category": "OTC",
    "subCategory": "GI",
    "drugClass": "Antidiarrheal",
    "route": "Oral",
    "commonDoseStrengths": "2 mg",
    "commonFrequency": "As needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Loratadine",
    "category": "OTC",
    "subCategory": "Allergy",
    "drugClass": "Antihistamine",
    "route": "Oral",
    "commonDoseStrengths": "10 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Losartan",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "ARB",
    "route": "Oral",
    "commonDoseStrengths": "25 mg; 50 mg; 100 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Losartan/hydrochlorothiazide",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "50/12.5 mg; 100/12.5 mg; 100/25 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Magnesium hydroxide",
    "category": "OTC",
    "subCategory": "Constipation",
    "drugClass": "Saline Laxative",
    "route": "Oral",
    "commonDoseStrengths": "Suspension",
    "commonFrequency": "As needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Magnesium oxide",
    "category": "OTC",
    "subCategory": "Supplements",
    "drugClass": "Mineral",
    "route": "Oral",
    "commonDoseStrengths": "250 mg; 400 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Metformin",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Biguanide",
    "route": "Oral",
    "commonDoseStrengths": "500 mg; 850 mg; 1000 mg",
    "commonFrequency": "Once daily or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Metformin XR",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Biguanide",
    "route": "Oral",
    "commonDoseStrengths": "500 mg; 750 mg; 1000 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Methyldopa",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Alpha-2 Agonist",
    "route": "Oral",
    "commonDoseStrengths": "250 mg; 500 mg",
    "commonFrequency": "Two to three times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Methylprednisolone",
    "category": "Other",
    "subCategory": "Inflammation",
    "drugClass": "Corticosteroid",
    "route": "Oral",
    "commonDoseStrengths": "4 mg; 8 mg; 16 mg",
    "commonFrequency": "As directed",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Metoclopramide",
    "category": "Other",
    "subCategory": "GI",
    "drugClass": "Prokinetic",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 10 mg",
    "commonFrequency": "Three to four times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Metolazone",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Thiazide-like Diuretic",
    "route": "Oral",
    "commonDoseStrengths": "2.5 mg; 5 mg; 10 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Metoprolol succinate",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Beta Blocker",
    "route": "Oral",
    "commonDoseStrengths": "25 mg; 50 mg; 100 mg; 200 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Metoprolol tartrate",
    "category": "Cardiovascular",
    "subCategory": "CAD",
    "drugClass": "Beta Blocker",
    "route": "Oral",
    "commonDoseStrengths": "25 mg; 50 mg; 100 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Miconazole cream",
    "category": "OTC",
    "subCategory": "Dermatology",
    "drugClass": "Antifungal",
    "route": "Topical",
    "commonDoseStrengths": "2%",
    "commonFrequency": "Twice daily",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Minoxidil",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Direct Vasodilator",
    "route": "Oral",
    "commonDoseStrengths": "2.5 mg; 10 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Montelukast",
    "category": "Other",
    "subCategory": "Respiratory",
    "drugClass": "Leukotriene Receptor Antagonist",
    "route": "Oral",
    "commonDoseStrengths": "10 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Mupirocin",
    "category": "Other",
    "subCategory": "Dermatology",
    "drugClass": "Topical Antibiotic",
    "route": "Topical",
    "commonDoseStrengths": "2%",
    "commonFrequency": "Two to three times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Naproxen",
    "category": "OTC",
    "subCategory": "Pain/Fever",
    "drugClass": "NSAID",
    "route": "Oral",
    "commonDoseStrengths": "220 mg; 250 mg; 500 mg",
    "commonFrequency": "Twice daily or as needed",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Nebivolol",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Beta Blocker",
    "route": "Oral",
    "commonDoseStrengths": "2.5 mg; 5 mg; 10 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Nifedipine ER",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Calcium Channel Blocker",
    "route": "Oral",
    "commonDoseStrengths": "30 mg; 60 mg; 90 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Nitroglycerin",
    "category": "Cardiovascular",
    "subCategory": "CAD",
    "drugClass": "Nitrate",
    "route": "Sublingual",
    "commonDoseStrengths": "0.3 mg; 0.4 mg; 0.6 mg",
    "commonFrequency": "Every 5 min as needed",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Nitroglycerin patch",
    "category": "Cardiovascular",
    "subCategory": "CAD",
    "drugClass": "Nitrate",
    "route": "Transdermal",
    "commonDoseStrengths": "0.2 mg/hr; 0.4 mg/hr; 0.6 mg/hr",
    "commonFrequency": "Daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Olmesartan",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "ARB",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 20 mg; 40 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Olmesartan/amlodipine/hydrochlorothiazide",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "20/5/12.5 mg; 40/5/12.5 mg; 40/10/25 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Olmesartan/hydrochlorothiazide",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "20/12.5 mg; 40/12.5 mg; 40/25 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Omega-3 fatty acids",
    "category": "OTC",
    "subCategory": "Supplements",
    "drugClass": "Omega-3",
    "route": "Oral",
    "commonDoseStrengths": "1000 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Omeprazole",
    "category": "OTC",
    "subCategory": "GI",
    "drugClass": "PPI",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 20 mg; 40 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Ondansetron",
    "category": "Other",
    "subCategory": "GI",
    "drugClass": "Antiemetic",
    "route": "Oral",
    "commonDoseStrengths": "4 mg; 8 mg",
    "commonFrequency": "Every 8 to 12 hours as needed",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Pantoprazole",
    "category": "OTC",
    "subCategory": "GI",
    "drugClass": "PPI",
    "route": "Oral",
    "commonDoseStrengths": "20 mg; 40 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Paracetamol",
    "category": "OTC",
    "subCategory": "Pain/Fever",
    "drugClass": "Analgesic",
    "route": "Oral",
    "commonDoseStrengths": "500 mg; 1000 mg",
    "commonFrequency": "Every 4 to 8 hours as needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Patiromer",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Potassium Binder",
    "route": "Oral",
    "commonDoseStrengths": "8.4 g; 16.8 g; 25.2 g",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Perindopril",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "ACE Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "2 mg; 4 mg; 8 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Perindopril/indapamide",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "2/0.625 mg; 4/1.25 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Phenylephrine nasal",
    "category": "OTC",
    "subCategory": "Cold/Flu",
    "drugClass": "Decongestant",
    "route": "Nasal",
    "commonDoseStrengths": "0.25%; 1%",
    "commonFrequency": "As needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Pioglitazone",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Thiazolidinedione",
    "route": "Oral",
    "commonDoseStrengths": "15 mg; 30 mg; 45 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Pitavastatin",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "Statin",
    "route": "Oral",
    "commonDoseStrengths": "1 mg; 2 mg; 4 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Polyethylene glycol",
    "category": "OTC",
    "subCategory": "Constipation",
    "drugClass": "Laxative",
    "route": "Oral",
    "commonDoseStrengths": "17 g",
    "commonFrequency": "Once daily as needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Potassium chloride",
    "category": "OTC",
    "subCategory": "Supplements",
    "drugClass": "Electrolyte",
    "route": "Oral",
    "commonDoseStrengths": "10 mEq; 20 mEq",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Prasugrel",
    "category": "Cardiovascular",
    "subCategory": "CAD",
    "drugClass": "Antiplatelet",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 10 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Pravastatin",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "Statin",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 20 mg; 40 mg; 80 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Prednisolone",
    "category": "Other",
    "subCategory": "Inflammation",
    "drugClass": "Corticosteroid",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 20 mg",
    "commonFrequency": "Once daily or as directed",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Prednisone",
    "category": "Other",
    "subCategory": "Inflammation",
    "drugClass": "Corticosteroid",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 10 mg; 20 mg; 50 mg",
    "commonFrequency": "Once daily or as directed",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Pregabalin",
    "category": "Other",
    "subCategory": "Neurology",
    "drugClass": "Neuropathic Pain Agent",
    "route": "Oral",
    "commonDoseStrengths": "25 mg; 50 mg; 75 mg; 150 mg; 300 mg",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Propafenone",
    "category": "Cardiovascular",
    "subCategory": "Electrophysiology",
    "drugClass": "Antiarrhythmic",
    "route": "Oral",
    "commonDoseStrengths": "150 mg; 225 mg; 300 mg",
    "commonFrequency": "Three times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Propranolol",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Beta Blocker",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 20 mg; 40 mg; 80 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Pseudoephedrine",
    "category": "OTC",
    "subCategory": "Cold/Flu",
    "drugClass": "Decongestant",
    "route": "Oral",
    "commonDoseStrengths": "30 mg; 60 mg",
    "commonFrequency": "Every 4 to 6 hours as needed",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Rabeprazole",
    "category": "OTC",
    "subCategory": "GI",
    "drugClass": "PPI",
    "route": "Oral",
    "commonDoseStrengths": "20 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Ramipril",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "ACE Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "1.25 mg; 2.5 mg; 5 mg; 10 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Ranolazine",
    "category": "Cardiovascular",
    "subCategory": "CAD",
    "drugClass": "Antianginal",
    "route": "Oral",
    "commonDoseStrengths": "500 mg; 1000 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Repaglinide",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Meglitinide",
    "route": "Oral",
    "commonDoseStrengths": "0.5 mg; 1 mg; 2 mg",
    "commonFrequency": "Before meals",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Rivaroxaban",
    "category": "Cardiovascular",
    "subCategory": "Electrophysiology",
    "drugClass": "Anticoagulant",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 15 mg; 20 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Rosuvastatin",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "Statin",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 10 mg; 20 mg; 40 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Sacubitril/valsartan",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "ARNI",
    "route": "Oral",
    "commonDoseStrengths": "24/26 mg; 49/51 mg; 97/103 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Sacubitril/valsartan/empagliflozin",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Reference Placeholder",
    "route": "Oral",
    "commonDoseStrengths": "N/A",
    "commonFrequency": "N/A",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Salbutamol",
    "category": "Other",
    "subCategory": "Respiratory",
    "drugClass": "Beta-2 Agonist",
    "route": "Inhaled",
    "commonDoseStrengths": "100 mcg",
    "commonFrequency": "As needed",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Semaglutide",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "GLP-1 Receptor Agonist",
    "route": "Injection/Oral",
    "commonDoseStrengths": "0.25 mg weekly; 0.5 mg weekly; 1 mg weekly; 2 mg weekly; 3 mg oral; 7 mg oral; 14 mg oral",
    "commonFrequency": "Once weekly or once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Senna",
    "category": "OTC",
    "subCategory": "Constipation",
    "drugClass": "Stimulant Laxative",
    "route": "Oral",
    "commonDoseStrengths": "8.6 mg",
    "commonFrequency": "Once daily as needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Sertraline",
    "category": "Other",
    "subCategory": "Mental Health",
    "drugClass": "SSRI",
    "route": "Oral",
    "commonDoseStrengths": "25 mg; 50 mg; 100 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Simethicone",
    "category": "OTC",
    "subCategory": "GI",
    "drugClass": "Antiflatulent",
    "route": "Oral",
    "commonDoseStrengths": "80 mg; 125 mg",
    "commonFrequency": "As needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Simvastatin",
    "category": "Metabolic",
    "subCategory": "Lipids",
    "drugClass": "Statin",
    "route": "Oral",
    "commonDoseStrengths": "10 mg; 20 mg; 40 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Sitagliptin",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "DPP-4 Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "25 mg; 50 mg; 100 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Sitagliptin/metformin",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "50/500 mg; 50/850 mg; 50/1000 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Sodium bicarbonate",
    "category": "OTC",
    "subCategory": "GI",
    "drugClass": "Antacid",
    "route": "Oral",
    "commonDoseStrengths": "325 mg; 650 mg",
    "commonFrequency": "As needed",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Sodium picosulfate",
    "category": "OTC",
    "subCategory": "Constipation",
    "drugClass": "Stimulant Laxative",
    "route": "Oral",
    "commonDoseStrengths": "5 mg",
    "commonFrequency": "As needed",
    "rxOtc": "OTC/Rx"
  },
  {
    "drugName": "Sodium zirconium cyclosilicate",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Potassium Binder",
    "route": "Oral",
    "commonDoseStrengths": "5 g; 10 g",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Sotalol",
    "category": "Cardiovascular",
    "subCategory": "Electrophysiology",
    "drugClass": "Antiarrhythmic",
    "route": "Oral",
    "commonDoseStrengths": "80 mg; 120 mg; 160 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Spironolactone",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "MRA",
    "route": "Oral",
    "commonDoseStrengths": "12.5 mg; 25 mg; 50 mg; 100 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Sucralfate",
    "category": "Other",
    "subCategory": "GI",
    "drugClass": "Mucosal Protectant",
    "route": "Oral",
    "commonDoseStrengths": "1 g",
    "commonFrequency": "Two to four times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Tadalafil",
    "category": "Other",
    "subCategory": "Urology",
    "drugClass": "PDE-5 Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 10 mg; 20 mg",
    "commonFrequency": "Once daily or as needed",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Telmisartan",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "ARB",
    "route": "Oral",
    "commonDoseStrengths": "20 mg; 40 mg; 80 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Telmisartan/amlodipine",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "40/5 mg; 40/10 mg; 80/5 mg; 80/10 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Telmisartan/hydrochlorothiazide",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "40/12.5 mg; 80/12.5 mg; 80/25 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Teneligliptin",
    "category": "Metabolic",
    "subCategory": "Diabetes",
    "drugClass": "DPP-4 Inhibitor",
    "route": "Oral",
    "commonDoseStrengths": "20 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Ticagrelor",
    "category": "Cardiovascular",
    "subCategory": "CAD",
    "drugClass": "Antiplatelet",
    "route": "Oral",
    "commonDoseStrengths": "60 mg; 90 mg",
    "commonFrequency": "Twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Timolol eye drops",
    "category": "Other",
    "subCategory": "Ophthalmology",
    "drugClass": "Beta Blocker",
    "route": "Ophthalmic",
    "commonDoseStrengths": "0.25%; 0.5%",
    "commonFrequency": "Once or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Torsemide",
    "category": "Cardiovascular",
    "subCategory": "Heart Failure",
    "drugClass": "Loop Diuretic",
    "route": "Oral",
    "commonDoseStrengths": "5 mg; 10 mg; 20 mg; 100 mg",
    "commonFrequency": "Once daily or twice daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Tramadol",
    "category": "Other",
    "subCategory": "Pain",
    "drugClass": "Opioid Analgesic",
    "route": "Oral",
    "commonDoseStrengths": "50 mg",
    "commonFrequency": "Every 6 hours as needed",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Trimetazidine",
    "category": "Cardiovascular",
    "subCategory": "CAD",
    "drugClass": "Metabolic Antianginal",
    "route": "Oral",
    "commonDoseStrengths": "20 mg; 35 mg MR",
    "commonFrequency": "Two or three times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Valsartan",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "ARB",
    "route": "Oral",
    "commonDoseStrengths": "40 mg; 80 mg; 160 mg; 320 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Valsartan/amlodipine",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "5/160 mg; 10/160 mg; 5/320 mg; 10/320 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Valsartan/hydrochlorothiazide",
    "category": "Cardiovascular",
    "subCategory": "Hypertension",
    "drugClass": "Combination",
    "route": "Oral",
    "commonDoseStrengths": "80/12.5 mg; 160/12.5 mg; 160/25 mg; 320/25 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Verapamil",
    "category": "Cardiovascular",
    "subCategory": "Electrophysiology",
    "drugClass": "Rate Control",
    "route": "Oral",
    "commonDoseStrengths": "40 mg; 80 mg; 120 mg; 180 mg; 240 mg",
    "commonFrequency": "Once daily or multiple times daily",
    "rxOtc": "Rx"
  },
  {
    "drugName": "Vitamin B12",
    "category": "OTC",
    "subCategory": "Supplements",
    "drugClass": "Vitamin",
    "route": "Oral",
    "commonDoseStrengths": "500 mcg; 1000 mcg",
    "commonFrequency": "Once daily",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Vitamin C",
    "category": "OTC",
    "subCategory": "Supplements",
    "drugClass": "Vitamin",
    "route": "Oral",
    "commonDoseStrengths": "500 mg; 1000 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Vitamin D3",
    "category": "OTC",
    "subCategory": "Supplements",
    "drugClass": "Vitamin",
    "route": "Oral",
    "commonDoseStrengths": "1000 IU; 2000 IU; 5000 IU",
    "commonFrequency": "Once daily",
    "rxOtc": "OTC"
  },
  {
    "drugName": "Warfarin",
    "category": "Cardiovascular",
    "subCategory": "Electrophysiology",
    "drugClass": "Anticoagulant",
    "route": "Oral",
    "commonDoseStrengths": "1 mg; 2 mg; 2.5 mg; 3 mg; 4 mg; 5 mg; 6 mg; 7.5 mg; 10 mg",
    "commonFrequency": "Once daily",
    "rxOtc": "Rx"
  }
];

// ---------------------------------------------------------------------------
// Runtime catalog state (module-scoped cache)
// ---------------------------------------------------------------------------
// `_cache` holds the last-known good list from the API. Before the first
// successful load it is `null`; all sync getters fall back to
// FALLBACK_MEDICATIONS in that window so the UI never renders an empty list.
// ---------------------------------------------------------------------------

const API_BASE_URL = process.env.REACT_APP_API_URL;
const CATALOG_PATH = '/medication-catalog/';
const SEED_PATH = '/medication-catalog/seed';

let _cache = null;
let _inFlightLoad = null;
let _seedAttempted = false;

const byDrugName = (a, b) => a.drugName.localeCompare(b.drugName);

const sanitize = (entry) => ({
  drugName: (entry.drugName || '').trim(),
  category: entry.category ?? null,
  subCategory: entry.subCategory ?? null,
  drugClass: entry.drugClass ?? null,
  route: entry.route ?? null,
  commonDoseStrengths: entry.commonDoseStrengths ?? null,
  commonFrequency: entry.commonFrequency ?? null,
  rxOtc: entry.rxOtc ?? null,
  isCustom: !!entry.isCustom,
  id: entry.id,
});

/**
 * Post the embedded fallback list to the seed endpoint. Called only when the
 * API returns an empty catalog, so the one-time bootstrap happens automatically
 * without requiring a manual admin step. Seeding is idempotent on the server.
 */
const seedCatalogFromFallback = async () => {
  if (_seedAttempted || !API_BASE_URL) return;
  _seedAttempted = true;
  try {
    await fetch(`${API_BASE_URL}${SEED_PATH}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(
        FALLBACK_MEDICATIONS.map(({ isCustom: _ignored, ...rest }) => rest)
      ),
    });
  } catch (_err) {
    // Non-fatal: the UI already has the fallback in memory, so we'll just
    // retry on the next full page load.
  }
};

/**
 * Load the catalog from the backend. Resolves with the current cache (API
 * result when reachable, fallback otherwise). Concurrent callers share a
 * single in-flight request.
 */
export const loadMedicationCatalog = async () => {
  if (_inFlightLoad) return _inFlightLoad;

  _inFlightLoad = (async () => {
    if (!API_BASE_URL) {
      _cache = [...FALLBACK_MEDICATIONS].sort(byDrugName);
      return _cache;
    }
    try {
      const res = await fetch(`${API_BASE_URL}${CATALOG_PATH}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      if (Array.isArray(data) && data.length > 0) {
        _cache = data.map(sanitize).sort(byDrugName);
      } else {
        // Empty catalog → auto-seed from fallback, then re-fetch once.
        await seedCatalogFromFallback();
        try {
          const res2 = await fetch(`${API_BASE_URL}${CATALOG_PATH}`);
          const data2 = res2.ok ? await res2.json() : [];
          _cache = Array.isArray(data2) && data2.length > 0
            ? data2.map(sanitize).sort(byDrugName)
            : [...FALLBACK_MEDICATIONS].sort(byDrugName);
        } catch (_err) {
          _cache = [...FALLBACK_MEDICATIONS].sort(byDrugName);
        }
      }
    } catch (_err) {
      // Network/API error: fall back to the embedded list so the UI still works.
      _cache = [...FALLBACK_MEDICATIONS].sort(byDrugName);
    }
    return _cache;
  })();

  try {
    return await _inFlightLoad;
  } finally {
    _inFlightLoad = null;
  }
};

/**
 * Synchronous accessor used inside React useMemo hooks. Returns the cache when
 * available; otherwise returns the embedded fallback so the autocomplete still
 * has something to show before the first load resolves.
 */
export const getAllMedications = () => {
  if (_cache && _cache.length > 0) return _cache;
  return [...FALLBACK_MEDICATIONS].sort(byDrugName);
};

/**
 * Add a user-authored entry. POSTs to the backend and, on success, updates the
 * in-memory cache so subsequent sync reads reflect the new entry immediately.
 *
 * Throws on failure; the caller is responsible for surfacing the error.
 */
export const addCustomMedication = async (med) => {
  if (!API_BASE_URL) {
    throw new Error('API base URL is not configured');
  }
  const payload = {
    drugName: (med.drugName || '').trim(),
    category: (med.category || '').trim() || null,
    subCategory: (med.subCategory || '').trim() || null,
    drugClass: (med.drugClass || '').trim() || null,
    route: (med.route || '').trim() || null,
    commonDoseStrengths: (med.commonDoseStrengths || '').trim() || null,
    commonFrequency: (med.commonFrequency || '').trim() || null,
    rxOtc: (med.rxOtc || '').trim() || null,
  };
  if (!payload.drugName) {
    throw new Error('Drug Name is required.');
  }

  const res = await fetch(`${API_BASE_URL}${CATALOG_PATH}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    let detail = `Request failed with status ${res.status}`;
    try {
      const body = await res.json();
      if (body?.detail) detail = body.detail;
    } catch (_err) {
      /* keep default */
    }
    throw new Error(detail);
  }

  const created = sanitize(await res.json());
  const currentCache = _cache && _cache.length > 0 ? _cache : [...FALLBACK_MEDICATIONS];
  const withoutDup = currentCache.filter(
    (m) => m.drugName.toLowerCase() !== created.drugName.toLowerCase()
  );
  _cache = [...withoutDup, created].sort(byDrugName);
  return created;
};

export const splitDoseStrengths = (str) => {
  if (!str) return [];
  return str
    .split(/[;,\n]/)
    .map((s) => s.trim())
    .filter(Boolean);
};

export const splitFrequencies = (str) => {
  if (!str) return [];
  return str
    .split(/\s+or\s+|;|\n/i)
    .map((s) => s.trim())
    .filter(Boolean);
};

export { FALLBACK_MEDICATIONS };
export default FALLBACK_MEDICATIONS;
